import { render, staticRenderFns } from "./handType.vue?vue&type=template&id=40905d5b&scoped=true&"
import script from "./handType.vue?vue&type=script&lang=js&"
export * from "./handType.vue?vue&type=script&lang=js&"
import style0 from "./handType.vue?vue&type=style&index=0&id=40905d5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40905d5b",
  null
  
)

export default component.exports